import { toast } from "@/components/ui/toast";

/**
 * Clears persisted session data and redirects. Full page reload re-hydrates stores
 * from empty storage, so an in-memory Zustand reset is not required.
 */
export const endSession = (redirectTo = "/auth/login") => {
  window.localStorage.clear();
  window.sessionStorage.clear();

  if (window.navigator?.credentials) {
    navigator.credentials.preventSilentAccess();
  }

  const url = new URL(redirectTo, window.location.origin);
  url.searchParams.set("t", Date.now().toString());
  window.location.replace(url.toString());
};

/** Clears session and redirects to login when the access token cannot be refreshed. */
export const handleSessionExpired = () => {
  toast.error("Your session has expired. Please log in again.");
  endSession();
};
